import { Box, Grid, Modal, Tabs, Typography, styled } from '@mui/material';
import Column from '../components/Column';
import { Error, CheckCircle } from '@mui/icons-material';

export const ModalButton = styled('button')<{ url: string }>(({ url }) => ({
  all: 'unset',
  cursor: 'pointer',
  height: 64,
  width: 64,
  backgroundImage: `url(${url})`,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  position: 'relative',
}));

export const CustomTabs = styled(Tabs)(({ theme }) => ({
  borderBottom: '1px solid #F2F4F7',
  marginBottom: theme.spacing(1),
  [theme.breakpoints.down('sm')]: {
    '&>div': {
      overflowX: 'scroll!important',
    },
  },
  '& button': {
    width: 'fit-content',
    minWidth: 90,
    fontSize: 14,
    fontWeight: '400',
    lineHeight: '16.8px',
    '&:hover': {
      color: theme.palette.primary.main,
    },
  },
}));

export const CustomBadge = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: theme.spacing(-1.25),
  right: theme.spacing(-1.5),
  width: '22px!important',
  height: '22px!important',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: theme.palette.primary.main,
  color: 'white',
  borderRadius: '50%',
  padding: theme.spacing(0.5),
  fontSize: 12,
  fontWeight: 600,
  lineHeight: '16px',
}));

export const OverlayText = styled(Typography)(({ theme }) => ({
  position: 'absolute',
  bottom: '10px',
  color: 'white',
  backgroundColor: theme.palette.grey[300],
  textTransform: 'uppercase',
  fontSize: '12px',
  fontWeight: '600',
  padding: '4px 8px',
  borderRadius: '2px',
  left: '50%',
  transform: `translateX(-50%)`,
  whiteSpace: 'nowrap',
}));

export const StyledCustomerPage = styled(Column)(({ theme }) => ({
  paddingTop: theme.spacing(4),
  maxHeight: '100%',
  '& h2': {
    marginBottom: theme.spacing(4),
  },
  '>div': {
    marginLeft: 0,
    width: `calc(100% + ${theme.spacing(3)})`,
    margin: `-${theme.spacing(1.5)}`,
    '>div': {
      padding: `${theme.spacing(1.5)}!important`,
    },
  },
}));

export const ErrorIconWrapper = styled(Error)(({ theme }) => ({
  color: theme.palette.error.main,
  marginRight: theme.spacing(1),
  width: '22px',
  height: '22px',
}));

export const TrustIconWrapper = styled(CheckCircle)(({ theme }) => ({
  color: theme.palette.success.main,
  marginRight: theme.spacing(1),
  width: '22px',
  height: '22px',
}));

export const AlertFlexColumn = styled(Column)(({ theme }) => ({
  '&>p': {
    marginBottom: theme.spacing(0.75),
  },
}));

export const CustomModal = styled(Modal)(({ theme }) => ({
  borderRadius: theme.spacing(0.5),
  alignContent: 'center',
  display: 'flex',
  alignItems: 'center',
}));

export const CustomModalContent = styled(Grid)(({ theme }) => ({
  padding: theme.spacing(3),
  width: 600,
  maxHeight: '80vh',
  overflowY: 'scroll',
  overflowX: 'clip',
  backgroundColor: 'white',
  margin: '0 auto',
  borderRadius: 4,
  outline: 0,
}));

export const SimpleLinkButton = styled('button')(({ theme }) => ({
  all: 'unset',
  '&:hover': {
    cursor: 'pointer',
  },
  '&>p': {
    color: theme.palette.primary.main,
    textTransform: 'uppercase',
    fontWeight: 600,
  },
}));

export const ExplainButton = styled('button')(({ theme }) => ({
  all: 'unset',
  border: `1px solid ${theme.palette.grey[600]}`,
  borderRadius: theme.spacing(0.5),
  padding: theme.spacing(0.375, 0.75),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  '&:hover': {
    cursor: 'pointer',
  },
  '&>svg': {
    color: theme.palette.grey[600],
    marginRight: theme.spacing(0.5),
    fontSize: 15,
  },
  '&>p': {
    color: theme.palette.grey[600],
    textTransform: 'uppercase',
    fontSize: 12,
    fontWeight: 500,
    lineHeight: '12px',
  },
}));

const SquaredBox = styled(Box)(({ theme }) => ({
  width: theme.spacing(4),
  height: theme.spacing(4),
}));

export const SquaredBoxCenteredContent = styled(SquaredBox)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: theme.spacing(0.5),
}));
